/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartPurchaseButton_item$ref = any;
export type CartPurchaseButton_item = {
    readonly serviceId: string | null;
    readonly ecommerceTrackingParams: unknown | null;
    readonly " $refType": CartPurchaseButton_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartPurchaseButton_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "ecommerceTrackingParams",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'f5eb1911b38e47bf5cae782721059876';
export default node;
